import React, { useEffect } from "react";
import { Mail, Linkedin } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { Card } from "../components/ui/card";
import { Avatar, AvatarFallback } from "../components/ui/avatar";
import { useDispatch, useSelector } from "react-redux";
import { getTeams } from "../features/team/teamSlice";

const Team = () => {
  const { t } = useLanguage();
  const dispatch = useDispatch();
  const { teams, loading } = useSelector((state) => state.team);

  useEffect(() => {
    dispatch(getTeams());
  }, [dispatch]);

  const getInitials = (name) =>
    name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase();

  const avatarColors = [
    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
    "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
    "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
    "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
    "linear-gradient(135deg, #30cfd0 0%, #330867 100%)",
  ];

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section
        style={{
          padding: "8rem 1.5rem 4rem",
          background:
            "radial-gradient(at 50% 30%, hsla(108,100%,50%,0.2) 0px, transparent 50%)",
          textAlign: "center",
        }}
      >
        <div className="max-w-4xl mx-auto">
          <h1
            style={{
              fontWeight: 700,
              fontSize: "clamp(2.25rem, 5vw, 4rem)",
              lineHeight: 0.9,
              letterSpacing: "-0.02em",
              color: "rgb(0, 55, 32)",
              marginBottom: "1.5rem",
            }}
          >
            {t.team.title}
          </h1>
          <p
            style={{
              fontSize: "clamp(1.125rem, 2.5vw, 1.25rem)",
              lineHeight: 1.5,
              color: "rgb(131, 146, 140)",
              maxWidth: "700px",
              margin: "0 auto",
            }}
          >
            {t.team.subtitle}
          </p>
        </div>
      </section>

      {/* Team Grid */}
      <section
        style={{
          padding: "4rem 1.5rem 6rem",
          background: "white",
        }}
      >
        <div className="max-w-6xl mx-auto">
          {loading ? (
            <p className="text-center text-gray-500">Loading...</p>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {teams?.data?.map((member, index) => (
                <Card
                  key={member.id}
                  style={{
                    background: "white",
                    border: "1px solid rgba(0, 0, 0, 0.1)",
                    borderRadius: "12px",
                    padding: "2rem",
                    boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
                    textAlign: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginBottom: "1.5rem",
                    }}
                  >
                    {member.avatar ? (
                      <img
                        src={`${member.avatar}`}
                        alt={member.name}
                        style={{
                          width: "96px",
                          height: "96px",
                          borderRadius: "50%",
                          objectFit: "cover",
                          border: "4px solid rgba(148, 242, 127, 0.2)",
                        }}
                      />
                    ) : (
                      <Avatar
                        style={{
                          width: "96px",
                          height: "96px",
                          background:
                            avatarColors[index % avatarColors.length],
                          border: "4px solid rgba(148, 242, 127, 0.2)",
                        }}
                      >
                        <AvatarFallback
                          style={{
                            background: "transparent",
                            color: "white",
                            fontSize: "1.5rem",
                            fontWeight: 700,
                          }}
                        >
                          {getInitials(member.name)}
                        </AvatarFallback>
                      </Avatar>
                    )}
                  </div>

                  <h3
                    style={{
                      fontWeight: 600,
                      fontSize: "1.25rem",
                      color: "rgb(0, 55, 32)",
                    }}
                  >
                    {member.name}
                  </h3>

                  <div
                    style={{
                      display: "inline-block",
                      padding: "0.25rem 0.75rem",
                      background: "rgba(148, 242, 127, 0.1)",
                      borderRadius: "9999px",
                      fontSize: "0.875rem",
                      fontWeight: 500,
                      color: "rgb(13, 121, 22)",
                      marginBottom: "1rem",
                    }}
                  >
                    {member.jabatan || "Anggota"}
                  </div>

                  <p
                    style={{
                      fontSize: "0.875rem",
                      color: "rgb(131, 146, 140)",
                      marginBottom: "1.5rem",
                    }}
                  >
                    {member.keterangan || "-"}
                  </p>

                  <div
                    style={{
                      display: "flex",
                      gap: "0.75rem",
                      justifyContent: "center",
                    }}
                  >
                    {/* <button className="hover:bg-gray-100 rounded-full p-2 border">
                      <Mail size={18} />
                    </button>
                    <button className="hover:bg-gray-100 rounded-full p-2 border">
                      <Linkedin size={18} />
                    </button> */}
                  </div>
                </Card>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Team;
